import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    platform: null,
    bankName: ''
  },
  getters: {
    getPlatform: state => state.platform,
    getBankName: state => state.bankName
  },
  mutations: {
    SET_PLATFORM(state, platform) {
      state.platform = platform
    },
    SET_BANK_NAME(state, bankName) {
      state.bankName = bankName
    }
  },
  actions: {
    setPlatform({ commit }, platform) {
      commit('SET_PLATFORM', platform)
    },
    setBankName({ commit }, bankName) {
      commit('SET_BANK_NAME', bankName)
    }
  },
  modules: {
    auth
  }
})
